import React, { Component, useState, useEffect } from 'react';
import { Col, Row, Button, Input } from 'reactstrap';
import { Editor } from '@tinymce/tinymce-react';


class Email extends Component {


    constructor(props) {

        super(props);
        this.state = {
            subject: '',
            editorText: '',
            sentFrom: 'Christian Rodee <crodee@ionsolar.com>',
            setter: false,
            manager: false,
            closer: false,
            setterManagers: false
        };

        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.sendTestEmail = this.sendTestEmail.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.subjectChange = this.subjectChange.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleCheckCloser = this.handleCheckCloser.bind(this);
        this.handleCheckManager = this.handleCheckManager.bind(this);
        this.handleCheckSetterManager = this.handleCheckSetterManager.bind(this);
        this.getActiveTeams = this.getActiveTeams.bind(this);

        this.getActiveTeams();
    }


    getActiveTeams() {

        // fetch('https://dev.iondeveloper.com/api/rep/_class/salesteam.class.php', {
        //     method: 'post',
        //     body: JSON.stringify(
        //         {
        //             "method": "get_active_teams",
        //         }
        //     )
        // }).then(function(response) {
        //     return response.json();
        // }).then(function(data) {
        //     console.log(data);
        // });

    }

    handleEditorChange(event) {


        this.setState({
            editorText: event.level.content
        });

    }

    subjectChange(event) {
        this.setState({
            subject: event.target.value
        });
    }



    sendEmail() {

        let r = window.confirm("Are you sure you want to send these emails?");
        console.log(this.state);

        let body = {
            "from": this.state.sentFrom,
            "subject": this.state.subject,
            "htmlBody": this.state.editorText,
            "manager": this.state.manager,
            "closer": this.state.closer,
            "setterManager": this.state.setterManagers,
            "setter": this.state.setter
        };

        console.log(body);

        if (r === true) {

            fetch('https://dev.iondeveloper.com/api/rep/_class/MailAllAdmin.class.php', {
                method: 'post',
                body: JSON.stringify(
                    {
                        "from": this.state.sentFrom,
                        "subject": this.state.subject,
                        "htmlBody": this.state.editorText,
                        "manager": this.state.manager,
                        "closer": this.state.closer,
                        "setterManager": this.state.setterManagers,
                        "setter": this.state.setter,
                        "isTest": false
                    }
                )
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                console.log(data);
            });

            alert("Emails are sending now...");
        } else {

        }

    }

    sendTestEmail() {


        fetch('https://dev.iondeveloper.com/api/rep/_class/MailAllAdmin.class.php', {
            method: 'post',
            body: JSON.stringify(
                {
                    "from": this.state.sentFrom,
                    "subject": this.state.subject,
                    "htmlBody": this.state.editorText,
                    "manager": this.state.manager,
                    "closer": this.state.closer,
                    "setterManager": this.state.setterManagers,
                    "setter": this.state.setter,
                    "isTest": true,
                }
            )
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            console.log(data);

        });

    }

    handleChange(event) {
        this.setState({
            sentFrom: event.target.value
        });
    }

    setTo(event) {
        console.log(event.target.value);
    }

    handleCheck() {

        let status;
        if (this.state.setter === true) {
            status = false;
        }
        if (this.state.setter === false) {
            status = true;
        }
        this.setState({
            setter: status
        });



    }
    ç
    handleCheckCloser() {

        let status;
        if (this.state.closer === true) {
            status = false;
        }
        if (this.state.closer === false) {
            status = true;
        }
        this.setState({
            closer: status
        });


    }

    handleCheckManager() {

        let status;
        if (this.state.manager === true) {
            status = false;
        }
        if (this.state.manager === false) {
            status = true;
        }
        this.setState({
            manager: status
        });

    }

    handleCheckSetterManager() {

        let status;
        if (this.state.setterManagers === true) {
            status = false;
        }
        if (this.state.setterManagers === false) {
            status = true;
        }
        this.setState({
            setterManagers: status
        });

    }


    render() {
        console.log(this.state)


        return (
            <div>
                <script src="https://cloud.tinymce.com/stable/tinymce.min.js"></script>
                <div className="email-container">
                    <h5>Send email to sales reps.</h5>
                    <div>
                        <p>
                            <a target="_blank" href="https://app.iondeveloper.com/admin-file-upload/?key=8e2e4875-20f1-4295-8664-2e4a7d75dd20">
                                <button class="upload-file-button">Upload File</button>
                            </a>
                        </p>
                    </div>
                    <input type="checkbox" onChange={this.handleCheckManager.bind(this)} defaultChecked={this.state.manager} /> Managers
                    <br />
                    <input type="checkbox" onChange={this.handleCheckSetterManager.bind(this)} defaultChecked={this.state.setterManager} /> Setter Managers
                    <br />
                    <input type="checkbox" onChange={this.handleCheckCloser.bind(this)} defaultChecked={this.state.closer} /> Closers
                    <br />
                    <input type="checkbox" onChange={this.handleCheck.bind(this)} defaultChecked={this.state.setter} /> Setters
                    <br />
                    <br />
                    <Input style={{ backgroundColor: "white !important" }} className="subject" type="text" placeholder="Email Subject Line" value={this.state.subject} onChange={this.subjectChange} ></Input>
                    <Editor
                        apiKey="g8woicsi9boon009tw3aqwzyfhi13c7sqrheft7o2fjlntsf"
                        initialValue=""
                        init={{
                            height: "270",
                            plugins: 'link image code',
                            toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code'
                        }}
                        onChange={this.handleEditorChange}
                    />


                    <div className="container">
                        <Row>
                            <Col xs="12" sm="12" md="12" lg="4" center >
                                <button type="button" className="form-submit small-button float-left" onClick={this.sendTestEmail} >Send TEST Email</button>
                            </Col>
                            <Col xs="12" sm="12" md="12" lg="4" center >
                                <Input value={this.state.sentFrom} onChange={this.handleChange} type="select" name="select" id="sentFrom">
                                    <option value="Christian Rodee <crodee@ionsolar.com>">Christian</option>
                                    <option value="Tad Thueson <tad@ionsolar.com>">Tad Thueson</option>
                                    <option value="Jeremy Call <jcall@ionsolar.com>">Jeremy Call</option>
                                    <option value="Andrew Shelby <andrew.shelby@ionsolar.com>">Andrew Shelby</option>
                                    <option value="Braxton Jex <bjex@ionsolar.com>">Braxton Jex</option>
                                    <option value="Colin Schmutz <colin@ionsolar.com>">Colin Schmutz</option>
                                    <option value="Development Team <dev@ionsolar.com>">Development</option>
                                </Input>
                            </Col>
                            <Col xs="12" sm="12" md="12" lg="4" center >
                                <button type="button" className="form-submit small-button send-real-email" onClick={this.sendEmail} >Send Email</button>
                            </Col>
                        </Row>
                    </div>


                </div>
            </div>
        );
    }



}


export default Email;




// WEBPACK FOOTER //
// ./src/components/shared/Email.js